// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2sAz6","rightAdornment":"Header_rightAdornment__1ATC4"};